import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import TypeLoanCRUD from './TypeLoan';

const TypeLoan = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de Tipos de Prestamo' pageTitle='Tipos de Prestamos' />
                <TypeLoanCRUD />
            </div>
        </React.Fragment>
    )
}

export default TypeLoan;